export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div>
            <div className="inline-block bg-gray-900 text-white px-4 py-2 rounded-full text-sm font-medium mb-6">
              關於我們 | About Us
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8 leading-tight" style={{ fontFamily: 'Noto Serif TC, serif' }}>
              我們相信：
              <br />
              真正的團隊，
              <br />
              不是靠口號
            </h2>
            <div className="space-y-6 text-lg text-gray-700 leading-relaxed mb-12">
              <p>
                真正的團隊，不是靠口號、不只是感情好，而是能在壓力下協作、在分歧中前進、在目標前一起扛責任。
              </p>
              <p>
                我們的團建，會讓人流汗、卡關、對話、甚至衝突——但也會讓人看見彼此真正的力量。因為只有經歷過挑戰，團隊才會真的靠在一起。
              </p>
              <p>
                我們把「玩」變成訓練，把「體驗」變成學習，把「感動」變成行動。團建結束不是終點，而是改變的起點。
              </p>
            </div>
            <div className="grid grid-cols-2 gap-8">
              <div>
                <div className="text-6xl font-bold text-black mb-2">200+</div>
                <div className="text-gray-600">服務企業</div>
              </div>
              <div>
                <div className="text-6xl font-bold text-black mb-2">95%</div>
                <div className="text-gray-600">客戶續約率</div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-2xl relative">
              <img
                src="https://public.readdy.ai/ai/img_res/a7a1224338a730cfb4a4a0fa4736e3d6.jpg"
                alt="團隊訓練現場"
                className="w-full h-full object-cover"
              />
              <div className="absolute top-6 left-6">
                <div className="bg-white px-4 py-2 rounded-full text-sm font-medium text-gray-900">
                  台北 · 新竹 · 台中
                </div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-8">
                <div className="text-white text-2xl font-bold">超過 5000 名學員</div>
                <div className="text-white/90 text-lg">親身體驗改變</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
